<div class="container-fluid" style="margin-top:100px ;" >
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 catalogue_wrapper">
                <div class="catalogue_header_img" >
                    <img src="../../../assets/images/CATALOUGE/clean(1).jpg">
                </div>
                <div >
                    <div style="margin-bottom: 15px;">
                        <h1 style="margin: 0;" class="catalogue_header">Painting Solutions</h1>
                        <div style="margin: 0 ; width: 40px; height: 3px; background-color: #76C5F0; border-radius: 50px;"></div>
                    </div>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Painting Services</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Deep Cleaning</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Water Proofing & Civil Work</h3>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 catalogue_wrapper">
                <div class="catalogue_header_img" >
                    <img src="../../../assets/images/CATALOUGE/Interior(2).jpg">
                </div>
                <div >
                    <div style="margin-bottom: 15px;">
                        <h1 style="margin: 0;" class="catalogue_header">Interiors & Project Solutions</h1>
                        <div style="margin: 0 ; width: 40px; height: 3px; background-color: #76C5F0; border-radius: 50px;"></div>
                    </div>
                    
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Wardrobe & Kitchen Cabinets</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Furniture procurement & installation</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Plants procurement & landscaping</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Electrical Fittings</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Balcony & Terrace Structures</h3>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 catalogue_wrapper">
                <div class="catalogue_header_img" >
                    <img src="../../../assets/images/CATALOUGE/Repaire(1).jpg">
                </div>
                <div >
                    <div style="margin-bottom: 15px;">
                        <h1 style="margin: 0;" class="catalogue_header">On-demand Services</h1>
                        <div style="margin: 0 ; width: 40px; height: 3px; background-color: #76C5F0; border-radius: 50px;"></div>
                    </div>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Electrical Repairs</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Plumbing Repairs</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Carpentry Repairs</h3>
                </div>
                <div style="display: flex; justify-content: start; align-items: center;">
                    
                    <h3 class="catalogue_items">&nbsp; &nbsp; &nbsp; • Documentations, Bill Payments</h3>
                </div>
            </div>
            
        </div>
    </div>
</div>